import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import {
  ILoginTokenResponse,
  ISecondStepResponse,
  ISignInData,
  SignInDataType,
} from '../../../models/auth/signIn.model';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';
import useSetAuthentication from '../useSetAuthentication';

// With passkeys required, a correct password returns a second-step ticket
// instead of tokens; `onSecondStep` receives it (ops spec K step 11).
const useSignin = (onSecondStep?: (step: ISecondStepResponse) => void) => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const { setAuthentication } = useSetAuthentication();

  const onSignInError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(err?.response?.data?.message ?? 'Something went wrong');
  };

  const onLoginSuccess = (response: SuccessHttpResponse<ILoginTokenResponse | ISecondStepResponse>) => {
    if ('second_step' in response.data) {
      onSecondStep?.(response.data);
      return;
    }
    const authData: ISignInData = {
      user: null,
      accessToken: { token: response.data.access_token },
      refreshToken: { token: response.data.refresh_token },
    };

    setAuthentication({ ...response, data: authData });
  };

  const signin = (data: SignInDataType) => {
    const url: HttpConfig = {
      url: 'api/v1/auth/admin/login',
      method: 'post',
      data,
      skipAuth: true,
    };

    request(url, onLoginSuccess, setLoading, onSignInError);
  };

  return {
    loading,
    signin,
  };
};

export default useSignin;
